import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";

import { queryClient } from "@/lib/queryClient";
import { AuthProvider } from "@/contexts/AuthContext";
import { I18nProvider } from "@/contexts/I18nContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import RootRedirect from "@/components/RootRedirect";
import SessionManager from "@/components/SessionManager";

import Layout from "@/components/layout/Layout";
import LoginPage from "@/pages/LoginPage";

import UsersPage from "@/pages/UsersPage";
import TestPage from "@/pages/TestPage";
import ErrorBoundary from "@/components/ErrorBoundary";
import "./App.css";
import MainPage from "./pages/MainPage";
import { devLog } from "@/lib/utils";

function App() {
  devLog("App component rendering...");

  return (
    <div id="app-root">
      <I18nProvider>
        <ErrorBoundary>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <SessionManager>
                <Router>
                <Routes>
                  <Route path="/test" element={<TestPage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/" element={<RootRedirect />} />
                  <Route
                    element={
                      <ProtectedRoute>
                        <Layout />
                      </ProtectedRoute>
                    }
                  >
                    <Route path="/main" element={<MainPage />} />
                    <Route path="/users" element={<UsersPage />} />
                  </Route>
                </Routes>
                </Router>
              </SessionManager>
            </AuthProvider>
          </QueryClientProvider>
        </ErrorBoundary>
      </I18nProvider>
    </div>
  );
}

export default App;
